// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"6ca4b652","229":"2a8a26e9","365":"1fd9a86a","453":"a5072149","859":"0a0c077c","928":"1e273b2f"}[chunkId] + ".chunk.js";
};